import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { Header } from './Header.js';
import { AIChatWidget } from '../ai/AIChatWidget.js';
import { DestructiveToolModal } from '../ai/DestructiveToolModal.js';
import { useUIStore } from '../../stores/uiStore.js';
import { cn } from '../../lib/utils.js';

const mainMarginMap = {
  expanded: 'ml-64',
  collapsed: 'ml-16',
  hidden: 'ml-0',
} as const;

export function MainLayout() {
  const sidebarState = useUIStore((s) => s.sidebarState);
  const location = useLocation();
  const isAIPage = location.pathname.startsWith('/ai');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar />
      <Header />
      <main
        className={cn(
          'pt-16 transition-all duration-300 ease-in-out',
          mainMarginMap[sidebarState],
        )}
      >
        {isAIPage ? (
          <Outlet />
        ) : (
          <div className="p-6">
            <Outlet />
          </div>
        )}
      </main>
      {/* AI Chat Widget — hidden on the AI full page */}
      {!isAIPage && <AIChatWidget />}
      {/* Destructive tool confirmation — global so it appears even if the user
          navigates away while a tool is paused (roadmap #48 PR-B) */}
      <DestructiveToolModal />
    </div>
  );
}
